import './App.css';
import LanguageSwitcher from './LanguageSwitcher';
import { useLanguage } from './i18n';

const imagesPath = process.env.PUBLIC_URL + '/images';
const logo = imagesPath + '/logo.png';
const productPhoto = imagesPath + '/product-photo.png';

function CreamPage() {
  const { href, messages } = useLanguage();
  const copy = messages.cream;

  return (
    <div className="page">
      <header className="hero hero-compact">
        <nav className="topbar" aria-label={messages.navigation}>
          <a className="brand" href={href('/')} aria-label={messages.brandPlain}>
            <img src={logo} className="brand-logo" alt={messages.logoAlt} />
            <span>{messages.brand}</span>
          </a>
          <LanguageSwitcher />
        </nav>
      </header>

      <main>
        <section className="section gel-page">
          <a className="back-link" href={href('/')}>
            ← {messages.home}
          </a>

          <div className="gel-page-header">
            <div>
              <p className="eyebrow">{messages.instruction}</p>
              <h1 className="gel-page-title">{copy.title}</h1>
              <p className="gel-page-subtitle">{copy.subtitle}</p>
            </div>
            <img
              src={productPhoto}
              className="gel-page-photo"
              alt={messages.app.creamAlt}
            />
          </div>

          <article className="gel-section">
            <p>{copy.intro}</p>
          </article>

          <article className="gel-section feature-card">
            <h2>{messages.composition}</h2>
            <p>{copy.composition}</p>
          </article>

          <article className="gel-section feature-card">
            <h2>{messages.application}</h2>
            <p>{copy.application}</p>
          </article>

          <article className="gel-section feature-card">
            <h2>{messages.storage}</h2>
            <p>{copy.storage}</p>
          </article>

          <article className="gel-section feature-card">
            <h2>{messages.contraindications}</h2>
            <p>{copy.contraindications}</p>
          </article>

          <article className="gel-section feature-card">
            <h2>{messages.shelfLife}</h2>
            <p>{copy.shelfLife}</p>
          </article>
        </section>

        <section className="notice">
          <strong>{messages.important}</strong> {messages.disclaimer}
        </section>
      </main>
    </div>
  );
}

export default CreamPage;
